var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block" },
    [
      _c(
        "el-carousel",
        {
          attrs: {
            arrow: _vm.alarmContent.length > 1 ? "always" : "never",
            interval: 3000,
            "indicator-position": _vm.alarmContent.length > 1 ? "" : "none"
          }
        },
        _vm._l(_vm.alarmContent, function(item, index) {
          return _c("el-carousel-item", { key: index }, [
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "head_style_button" },
                [
                  _c(
                    "el-button-group",
                    { staticClass: "ml-4" },
                    [
                      _c("el-button", {
                        attrs: {
                          type: "danger",
                          size: "small",
                          title: "隐藏提示框于左上角",
                          icon: "el-icon-minus"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showDeatil(item, index, 0)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-button", {
                        attrs: {
                          type: "danger",
                          size: "small",
                          title: "查看更多数据",
                          icon: "el-icon-s-data"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showDeatil(item, index, 1)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-button", {
                        attrs: {
                          type: "danger",
                          size: "small",
                          title: "解除本次报警",
                          icon: "el-icon-close-notification"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showDeatil(item, index, 2)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-button", {
                        attrs: {
                          type: "danger",
                          size: "small",
                          title: "查看报警位置",
                          icon: "el-icon-s-flag"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showDeatil(item, index, 3)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "box_title" }, [
                _c("img", {
                  staticClass: "img_icon title",
                  attrs: {
                    src:
                      "https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/alarm_icon.png"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.levelName))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box_content" }, [
                _c("div", { staticClass: "content-item" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../../static/img/icon/device_name.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(item.deviceName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content-item" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/address.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(item.devicePosition))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content-item" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../../static/img/icon/time.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(item.time))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "alarm",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.deal_alarm(item, index)
                      }
                    }
                  },
                  [_vm._v("接警")]
                )
              ])
            ])
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b878200c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b878200c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/alarm/alarm_box.vue
// module id = null
// module chunks = 